export enum VoucherSoundType {
  totalWinPopup = 'totalWinPopup',
  buttonClick = 'buttonClick',
  headerShow = 'headerShow',
  giftIconBounce = 'giftIconBounce',
  selectPopup = 'selectPopup',
}
